<section>
    <ng-content></ng-content>
</section>
